import React, { useEffect, useRef } from 'react';

export const useRefWithSubscribe = <T>(state: T): React.MutableRefObject<T> => {
  const ref = useRef(state);

  useEffect(() => {
    ref.current = state;
  }, [state]);

  return ref;
};
